export default __webpack_public_path__ + "static/media/ico_13.7b9dbea1.png";